// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"575":"components-UnknownPage","918":"components-MainPage"}[chunkId] || chunkId) + "." + {"211":"c373f1b39d7053fab9e0","575":"0af97c5a6c7ce9acf733","918":"a38e54b5b8baa2b2fb0c"}[chunkId] + ".js";
};